/*
  Component: AgentViewSwitcher
  Description: This component renders a radio group for switching between different views of agents.
  Author: Binish Mookken
  Date: April-June 2024

  Description:
  This component renders a radio group containing buttons for switching between different views of agents, such as Leader Board, Hierarchy, Graph, and Table. It receives a value prop indicating the currently selected view and an onChange prop to handle changes in the selected view.

  Props:
  - value: A string representing the currently selected view.
  - onChange: A function to handle changes in the selected view.

  Dependencies:
  - React: For building the UI components.
  - antd: Provides the Flex and Radio components for building the radio group.
*/

import React from "react";
import { Flex, Radio } from "antd";
import "./AgentsViewSwitcher.css";
import { ExperimentFilled } from "@ant-design/icons";
import { FaNetworkWired } from "react-icons/fa";

interface RadioGroupProps {
  value: string;
  onChange: (value: string) => void;
}

const AgentViewSwitcher: React.FC<RadioGroupProps> = ({ value, onChange }) => {
  return (
    <Flex gap="small" wrap="wrap" style={{ flex: "1" }}>
      <Radio.Group value={value} onChange={(e) => onChange(e.target.value)}>
        <Radio.Button value="leader" className="view-button">
          Leader Board
        </Radio.Button>
        <Radio.Button value="tree" className="view-button">
          Hierarchy
        </Radio.Button>
        {/* <Radio.Button value="graph" className="view-button">
          <ExperimentFilled /> Graph
        </Radio.Button> */}
        <Radio.Button value="table" className="view-button">
          Table
        </Radio.Button>
      </Radio.Group>
    </Flex>
  );
};

export default AgentViewSwitcher;
